  <template>
  <div v-if="account.role != 'admin'">
    <v-menu
      v-if="!$store.state._StoreWatcheeBox.isConnected"
      bottom
      left
    >
      <v-btn
        icon
        slot="activator"
      >
        <v-icon color="grey">warning</v-icon>
      </v-btn>
      <v-card>
        <v-card-text>
          <p>{{ $t('connectionChatLost') | cap }}</p>
          <v-btn
            block
            color="primary"
            @click="reload()"
          >{{ $t('reconnection') }}</v-btn>
        </v-card-text>
      </v-card>
    </v-menu>
    <v-menu
      v-else
      bottom
      left
      v-model="menu"
      v-scroll="onScroll"
    >
      <v-btn v-if="!$vuetify.breakpoint.smAndDown"  slot="activator" style="width: 150px;" small light>
        <span>{{ $t(selectStatus.value) | cap }}</span>
        <v-icon right :color="selectStatus.color">person_pin</v-icon>
      </v-btn>
      <v-icon v-else slot="activator" right :color="selectStatus.color">person_pin</v-icon>
      <v-list class="card" avatar dense>
        <v-list-tile
          v-for="item in statusAgent"
          :key="item.value"
          @click="item.value != 'busy' || user.canBeUnavailable
            ? switchToStatus(item.value)
            : $store.dispatch('_Notifier/NEW_NOTIF', { message: $t('noSwitchUnavailable'), context: 'warning' })"
          :disabled="item.value == 'busy' && !user.canBeUnavailable"
          >
          <v-icon :color="item.color" class="text--darken-2 mr-1" left>person_pin</v-icon>
          <v-list-tile-title>{{ $t(item.value) | cap }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapState, mapMutations } from 'vuex'
import _watcheebox from '../watcheebox/watcheebox.js'
export default {
  data () {
    return {
      menu: false,
      statusAgent: [
        {
          color: 'green', // class pour la couleur de l'icone
          value: 'online' // status de l'agent côté serveur
        },
        {
          color: 'orange', // class pour la couleur de l'icone
          value: 'busy' // status de l'agent côté serveur
        },
        {
          color: 'red', // class pour la couleur de l'icone
          value: 'offline' // status de l'agent côté serveur
        }
      ],
      selectStatus: {
        color: '',
        value: -1
      }
    }
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', ['SET_STATUS', 'SET_STATUS_MANUALLY']),
    ...mapMutations(['SET_REASON_UNLOAD']),
    switchToStatus (status) {
      // online on check si il n'est pas plein au niveau chat pour le passé 'occupé'
      if (status === 'online') {
        if (this.sessionsPrivees.length >= this.user.chatsMax) {
          status = 'busy'
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('noSwitchOnlineAvailable'),
            context: 'warning'
          })
        }
      }
      _watcheebox.changeStatusAgent({
        statut: status,
        agentID: this.user.id,
        sessionsPrivees: this.sessionsPrivees,
        roomName: this.user.entKey,
        socket: this.$socket
      })
      // Sauve en Session le status choisi manuellement
      this.SET_STATUS_MANUALLY(status)
    },
    onScroll (e) {
      this.menu = false
    },
    reload () {
      this.SET_STATUS('online')
      this.SET_REASON_UNLOAD('AgentStatus: connection chat perdue (node tombé)')
      window.location.reload()
    }
  },

  created () {
    this.selectStatus = _.clone(
      _.find(this.statusAgent, {
        value: this.$store.state._StoreWatcheeBox.status
      })
    )
  },

  watch: {
    // Au changement du status de l'agent : modification de la couleur du composant
    '$store.state._StoreWatcheeBox.status': function (val, oldVal) {
      this.selectStatus = _.clone(_.find(this.statusAgent, { value: val }))
      // console.log('change status', this.user.id)
      // enregistre dans la table la fermeture du chat deja en place
      let dataToPost = new window.FormData()
      dataToPost.append('agent_id', this.user.id)
      dataToPost.append('status', val)
      this.axios.post('post/addStatusAgent.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        // console.log('enregistre satus agent', response)
      })
    }
  },

  computed: {
    ...mapGetters('_StoreWatcheeBox', ['sessionsPrivees']),
    ...mapState('_StoreWatcheeBox', ['sessionsPrivees']),
    ...mapGetters('_User', ['user', 'account'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzAgentStatus.vue